'use strict';

/**
 * EventsOverview
 *
 * @author Jan Widmer <jan.widmer@namics.com>
 */
T.Module.EventsOverview = T.createModule({

	_selectors: {
		events: '[data-js-m-events-list__item]',
		button: '[data-js-o-events-overview__button]'
	},

	start: function start(resolve) {
		// References
		this.$ctx = $(this._ctx);

		// References
		this.$events = this.$ctx.find(this._selectors.events);
		this.$button = this.$ctx.find(this._selectors.button);

		this.initialVisibleItems = 15;
		this.loadMoreItems = 15;

		// Global Event Binding
		this._events.on('t.sync', this.sync.bind(this));

		// Component Event Binding
		this.$button.click(this.$onClickMoreButton.bind(this));

		// Lifecycle Callback
		resolve();
	},
	sync: function sync() {
		this.showInitialSelection();
	},
	$onClickMoreButton: function $onClickMoreButton() {
		this.maxShownCount = this.maxShownCount + this.loadMoreItems;

		this.$events.slice(0, this.maxShownCount).show();

		if (this.$events.length <= this.maxShownCount) {
			this.$button.hide();
		}
	},
	showInitialSelection: function showInitialSelection() {
		this.$events.hide();
		this.$events.slice(0, this.initialVisibleItems).show();

		this.maxShownCount = this.initialVisibleItems;

		if (this.$events.length <= this.maxShownCount) {
			this.$button.hide();
		} else {
			this.$button.show();
		}
	}
});